/**
 * Session-only event bus for "a World Cup pick was just saved to the server".
 * Used by post-first-pick prompts (Arena bridge, guest sign-up) to react
 * without needing to thread callbacks deep through the prediction UI.
 */

import { create } from 'zustand';

interface WcPickSavedEventState {
  /** Monotonically increasing counter; every successful save bumps this. */
  savedCount: number;
  /** Timestamp of the most recent save; null when none in this session. */
  lastSavedAt: number | null;
  /**
   * True when the WC→Arena onboarding bridge is expected on this user's first
   * pick (brand-new real user). The save hook reads it to suppress the generic
   * "Pick saved" toast on that pick, so the bridge snackbar shows alone instead
   * of replacing the toast mid-animation. Set at mount by PostFirstPickPromptManager.
   */
  bridgePending: boolean;
  bump: () => void;
  setBridgePending: (value: boolean) => void;
}

export const useWcPickSavedEventStore = create<WcPickSavedEventState>()((set) => ({
  savedCount: 0,
  lastSavedAt: null,
  bridgePending: false,
  bump: () => set((state) => ({
    savedCount: state.savedCount + 1,
    lastSavedAt: Date.now(),
  })),
  setBridgePending: (value: boolean) => set({ bridgePending: value }),
}));
